module.exports = __webpack_public_path__ + "img/record-icon.9ffa527e.svg";